// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
import { type BaseInterval } from './BaseInterval';

export class HistoryMergerInputParams {
    public BaseHistory: BaseInterval[];
    public NewPeriod: number;
    public Instrument: any; // IInstrument;
    public ShowExtendedSession: boolean = true;
}
